export const formatCurrency = (amount, currency = 'ILS') => {
  return new Intl.NumberFormat('he-IL', {
    style: 'currency',
    currency: currency,
  }).format(amount);
};

export const formatDate = (date) => {
  return new Date(date).toLocaleDateString('he-IL');
};

export const formatDateTime = (date) => {
  return new Date(date).toLocaleString('he-IL');
};

export const getUserTypeLabel = (userType) => {
  const labels = {
    trainer: 'מאמן',
    studio: 'סטודיו',
  };
  return labels[userType] || userType;
};

export const getStatusLabel = (status) => {
  const labels = {
    pending: 'ממתין לאישור',
    active: 'פעיל',
    inactive: 'לא פעיל',
    suspended: 'מושעה',
  };
  return labels[status] || status;
};

export const getStatusColor = (status) => {
  const colors = {
    pending: 'warning',
    active: 'success',
    inactive: 'error',
    suspended: 'error',
  };
  return colors[status] || 'default';
};

export const getPlanLabel = (plan) => {
  const labels = {
    free_trial: 'תקופת נסיון',
    monthly: 'מנוי חודשי',
    yearly: 'מנוי שנתי',
  };
  return labels[plan] || plan;
};

export const getPaymentStatusLabel = (status) => {
  const labels = {
    pending: 'ממתין',
    completed: 'הושלם',
    failed: 'נכשל',
    refunded: 'זוכה',
  };
  return labels[status] || status;
};

export const getPaymentStatusColor = (status) => {
  const colors = {
    pending: 'warning',
    completed: 'success',
    failed: 'error',
    refunded: 'info',
  };
  return colors[status] || 'default';
};

export const truncateText = (text, maxLength = 50) => {
  if (!text) return '';
  return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
};

export const calculateDaysAgo = (date) => {
  const now = new Date();
  const targetDate = new Date(date);
  const diffTime = Math.abs(now - targetDate);
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  
  if (diffDays === 0) return 'היום';
  if (diffDays === 1) return 'אתמול';
  return `לפני ${diffDays} ימים`;
};

export const isTokenExpired = (token) => {
  if (!token) return true;
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Date.now() / 1000;
    return payload.exp < currentTime;
  } catch (error) {
    return true;
  }
};
